import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useGetOtherReportBasicDataQuery } from "../../../../store/queries/Reports";
import { updateConfig } from "../../../../store/slices/Reports/reportsSlice";

const useFilter = () => {
  const dispatch = useDispatch();
  const certificateState = useSelector(
    (state) => state.reports?.certificateReport
  );
  const { data: basicData = {} } = useGetOtherReportBasicDataQuery({});

  const shopList = basicData?.data?.shop ?? [];
  const supplierList = basicData?.data?.supplier ?? [];
  const itemTypeList = basicData?.data?.item_types ?? [];

  const formik = useFormik({
    initialValues: {
      shop: certificateState?.filter?.shop ?? [],
      supplier: certificateState?.filter?.supplier ?? [],
      item_type: certificateState?.filter?.item_type ?? [],
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(
        updateConfig((state) => {
          state.certificateReport.showFilter = false;
          state.certificateReport.currentPage = 1;
          state.certificateReport.filter.shop = values?.shop ?? [];
          state.certificateReport.filter.supplier = values?.supplier ?? [];
          state.certificateReport.filter.item_type = values?.item_type ?? [];
        })
      );
    },
  });

  const handleReset = () => {
    formik?.handleReset();
    dispatch(
      updateConfig((state) => {
        state.certificateReport.showFilter = false;
        state.certificateReport.currentPage = 1;
        state.certificateReport.filter.shop = [];
        state.certificateReport.filter.supplier = [];
        state.certificateReport.filter.item_type = [];
      })
    );
  };

  return {
    formik,
    shopList,
    supplierList,
    itemTypeList,
    handleReset,
  };
};

export default useFilter;
